import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as websiteZoneActions from '../actions/websites-zone.action';
import {filter, map, switchMap} from 'rxjs/operators';
import {WebsiteService} from '../../websites/website.service';
import {Store} from '@ngrx/store';
import {DbStoreState} from '../reducers';
import {DbResponse} from "../../shared/interceptors/db-response";


@Injectable()
export class WebsitesZoneEffect {

  getVPZoneCreatedResponse$ = createEffect(() => this._actions$.pipe(
    ofType(websiteZoneActions.GET_VP_ZONE_CREATED_RESPONSE),
    switchMap(() => this._websiteService.getVPZoneCreatedResponse().pipe(
      filter((response: DbResponse) => !!response),
      map((response: DbResponse) => {
        if (response.success) {
          return new websiteZoneActions.GetVPZoneCreatedResponseSuccess(response.data);
        }
        return new websiteZoneActions.GetVPZoneCreatedResponseFail(response.message);
      })
    ))
  ));

  constructor(
    private _store: Store<DbStoreState>,
    private _actions$: Actions,
    private _websiteService: WebsiteService
  ) {
  }

}
